import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Subtle compliance footnote rendered under a primary action button (Sign In,
 * Create Account, Pay) on portal/payment surfaces. Acceptance is implicit via
 * the user's deliberate click — no checkbox required (industry-standard
 * pattern used by Stripe, GitHub, Linear).
 *
 * Usage:
 *   <LegalFootnote action="signing in" />
 *   <LegalFootnote action="creating an account" />
 *   <LegalFootnote action="submitting payment" />
 */
const LegalFootnote = ({ action = 'continuing', testId = 'pv2-legal-footnote' }) => (
  <p
    data-testid={testId}
    style={{
      marginTop: 14,
      fontSize: 11,
      lineHeight: 1.55,
      color: 'var(--pv2-text-subtle, rgba(255,255,255,0.45))',
      textAlign: 'center',
    }}
  >
    By {action}, you agree to our{' '}
    <Link
      to="/terms"
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testId}-terms`}
      style={{ color: 'var(--pv2-red-bright)', textDecoration: 'underline' }}
    >
      Terms
    </Link>
    {' '}and{' '}
    <Link
      to="/privacy"
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testId}-privacy`}
      style={{ color: 'var(--pv2-red-bright)', textDecoration: 'underline' }}
    >
      Privacy Policy
    </Link>
    .
  </p>
);

export default LegalFootnote;
